import { render, staticRenderFns } from "./SingleNotification.vue?vue&type=template&id=08495b67&scoped=true&"
import script from "./SingleNotification.vue?vue&type=script&lang=js&"
export * from "./SingleNotification.vue?vue&type=script&lang=js&"
import style0 from "./SingleNotification.vue?vue&type=style&index=0&id=08495b67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08495b67",
  null
  
)

export default component.exports